var constants = require("./constants")();

/**
 * Инкапсулирует методы, которые обрабаиывают URI для определение их персисентностив  семантическом смысле.
 * 
 * 1. Определяют, что URI может иметь человекочитаемую форму.
 *   Для этого используются специальные настройки в следующем JSON-формате: 
 * {
 * }
 */
module.exports = (function () {

	var persistentTools = {};


	persistentTools.textInLanguage = function (textObject, preferredLanguage) {
		if (typeof textObject === "undefined") {
			return undefined;
		}

		if (typeof textObject === "string") {
			return textObject;
		}

		if (preferredLanguage && textObject.hasOwnProperty(preferredLanguage)) {
			return textObject[preferredLanguage];
		}

		var textForLanguage = searchLanguage(textObject, "en");
		if (textForLanguage) {
			return textForLanguage;
		}
		textForLanguage = searchLanguage(textObject, constants.LANG_UNDEFINED);
		if (textForLanguage) {
			return textForLanguage;
		}

		return textObject[constants.LANG_IRIBASED];
	};


	function searchLanguage(textObject, preferredLanguage) {
		for (var language in textObject) {
			if (language === preferredLanguage && textObject.hasOwnProperty(language)) {
				return textObject[language];
			}
		}
	}

	return function () {
		/* Use a function here to keep a consistent style like webvowl.path.to.module()
		 * despite having just a single persistentTools object. */
		return persistentTools;
	};
})();
